import { offlineDatabase } from '../database/offlineDatabase/offlineDatabase';
import { createOfflineCommonRepository } from './common/createOfflineCommonRepository';

export const offlineProductColorsRepository = {
  ...createOfflineCommonRepository(() => offlineDatabase.productColors),
  findByProductId: (productId: string) => {
    const databaseTable = offlineDatabase.productColors;
    return databaseTable.filter((productColor) => productColor.productId === productId).toArray();
  },
  findRelatedProductColors: async (
    originalProductColorIds: string[],
    classificationIds: string[],
  ) => {
    const databaseTable = offlineDatabase.productColors;
    const productColorIdSet = new Set(originalProductColorIds);
    const classificationIdSet = new Set(classificationIds);

    const productColors = await databaseTable.toArray();

    return productColors.filter((pc) =>
      pc.classificationIds.some(
        (id) => classificationIdSet.has(id) && !productColorIdSet.has(pc.id),
      ),
    );
  },
};
